module.exports = __webpack_public_path__ + "static/media/TeamPink.4d0a8143.png";